import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import calculateHeaderParams from '@gcloud-npm/node.build-process.build-environments';
import Request from '@gcloud-npm/utils.request';
import { ADDRESS_HOST, FAMILY_API, PROCESS_NAME } from './constants';

const PATH = '/api/movistar-layer/address/v1/coverage/vertical-search';
const EVENT_NAME = 'LAYER_FORM.VERTICAL_SEARCH';

const searchVerticalAddresses = ({
  params,
  data,
  context,
  idFront = 'VT',
  build = false,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  const paramsString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  const URL_API = `${ADDRESS_HOST}${PATH}?${paramsString}`;
  const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: 'GET',
    endpoint: URL_API,
    headers: { ...headers2Use },
    sonda,
    data,
  });
  return request.makeRequest();
};

export default searchVerticalAddresses;
